export default {
    it: {
        "title": "Allegati inviati",
        "accordion-title": "Screenshot della problematica riscontrata",
        "attachment": "Allegato"


    },
    en: {
        "title": "Attachments sent",
        "accordion-title": "Screenshot of the problem encountered",
        "attachment": "Allegato"   
    }
}